var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentUploadOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#183433"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17608_166261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9991V14.9991H9V23.9991H23V14.9991H20V12.9991H23C24.1046 12.9991 25 13.8946 25 14.9991V23.9991C25 25.1037 24.1046 25.9991 23 25.9991H9C7.89543 25.9991 7 25.1037 7 23.9991V14.9991C7 13.8946 7.89543 12.9991 9 12.9991H12ZM16.8839 6.46768L20.2426 9.82644C20.6332 10.217 20.6332 10.8501 20.2426 11.2406C19.8521 11.6312 19.219 11.6312 18.8284 11.2406L17 9.41223V18.9991C17 19.5514 16.5523 19.9991 16 19.9991C15.4477 19.9991 15 19.5514 15 18.9991V9.41223L13.1716 11.2406C12.781 11.6312 12.1479 11.6312 11.7574 11.2406C11.3668 10.8501 11.3668 10.217 11.7574 9.82644L15.1161 6.46768C15.6043 5.97952 16.3957 5.97952 16.8839 6.46768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17608_166261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadOutline);
export default __webpack_public_path__ + "static/media/documentUploadOutline.f469f67ef3e27eae1dcd5ccd8046abb8.svg";
export { ForwardRef as ReactComponent };